import React, { useEffect, useState } from 'react'
import {
  Flex,
  H1WithBack,
  TabsContainer,
  Tabs,
  PageWrapper,
  ContentWrapper,
} from '../../styling/GlobalStyles'
import { AddEmployeerWrapper } from './AddEmployee.styled'
import { EmployeeBasicInfoTab } from './EmployeeBasicInfoTab'
import { EmployeesContractsTab } from './EmployeesContractsTab'
import { NavBar } from '../../components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { addUser } from 'features/users(Employees)/usersSlice'
import { AppDispatch, RootState } from 'store'
import { toast } from 'react-toastify'
import { IContract, IEmployee } from 'types/users.interface'
import { employeeBasicInfoTabInputs, employeesInitialState, invalidBankFieldsArray } from './employeesData'
import { EmployeeBankInfoTab } from './EmployeeBankInfoTab'
import { EmployeeWelfareTab } from './EmployeeWelfateTab'
import { EmployeesNotesTab } from './EmployeesNotesTab'

export const AddEmployeer = () => {
  const [active, setActive] = useState('Basic Info')
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [invalidFields, setInvalidFields] = useState(employeeBasicInfoTabInputs)
  const [invalidBankFields, setInvalidBankFields] = useState(invalidBankFieldsArray)
  const [invalidWelfareFields, setInvalidWelfareFields] = useState([])
  const [state, setState] = useState<IEmployee>({ ...employeesInitialState })
  const { user } = useSelector((state: RootState) => state.user)

  // useEffect(() => {
  //   if (user?.currentContract.role?.contractors) {
  //     setState(prev => ({ ...prev, accessType: 'contractor' }))
  //   }
  // }, [])

  const handleSubmit = async () => {
    try {
      if (invalidFields.length > 0) {
        toast.warn('All basic info fields must be valid')
        return
      }

      if (state.documents?.length && state.documents?.some(doc => !doc.effectiveDate || !doc.expiryDate || !doc.expiryDate || !doc.effectiveDate || !doc.category || !doc.documentFile)) {
        toast.warn('Please fill all document fields with valid values')
        return
      }

      if (state.notes.length && state.notes.some(note => !note.content || !note.visibilityScope || !note.category)) {
        toast.warn('Please fill all note fields with valid values')
        return
      }


      const resp = await dispatch(addUser(state))
      if (resp.meta.requestStatus === 'fulfilled') {
        navigate('/hr/employees')
      }
    } catch (err) {
      console.log(err)
    }

  }

  const renderTabs = () => {
    if (active === 'Basic Info') {
      return (
        <EmployeeBasicInfoTab
          setState={setState}
          state={state}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
          handleSubmit={handleSubmit}
        />
      )
    } else if (active === 'Bank Info') {
      return <EmployeeBankInfoTab setState={setState} state={state} handleSubmit={handleSubmit} invalidFields={invalidBankFields}
        setInvalidFields={setInvalidBankFields} />
    } else if (active === 'Welfare') {
      return <EmployeeWelfareTab setState={setState} state={state} setInvalidFields={setInvalidWelfareFields} invalidFields={invalidWelfareFields} handleSubmit={handleSubmit} />
    } else if (active === 'Contract') {
      return <EmployeesContractsTab setState={setState} state={state} handleSubmit={handleSubmit} />
    }
    return <EmployeesNotesTab setState={setState} state={state} handleSubmit={handleSubmit} />
  }

  const changeTab = (name: string) => {
    if (active == 'Contract' && state.contracts.some((c: IContract) => !c.value)) {
      toast.warn('Contracts must be saved first')
    } else if (active == 'Welfare' && invalidWelfareFields.length) {
      toast.warn('Please fill all required fields with valid values before proceeding')
    } else if (active == ' Bank Info' && invalidBankFields.length) {
      toast.warn('Please fill all required fields with valid values before proceeding')
    } else {
      setActive(name)
    }
  }


  return (
    <AddEmployeerWrapper>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack arrow title={'Add Employee'} />
          <TabsContainer>
            <Tabs active={active === 'Basic Info'} onClick={() => changeTab('Basic Info')}>
              Basic Info
            </Tabs>
            <Tabs active={active === 'Bank Info'} onClick={() => changeTab('Bank Info')}>
              Bank Info
            </Tabs>
            <Tabs active={active === 'Contract'} onClick={() => changeTab('Contract')}>
              Contract
            </Tabs>
            <Tabs active={active === 'Documents'} onClick={() => changeTab('Documents')}>
              Documents
            </Tabs>




          </TabsContainer>
        </Flex>
        <ContentWrapper noFooter>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </AddEmployeerWrapper>
  )
}
